export var QualityControlStep;
(function (QualityControlStep) {
    QualityControlStep["INTAKE"] = "intake";
    QualityControlStep["CHARTING"] = "charting";
})(QualityControlStep || (QualityControlStep = {}));
//# sourceMappingURL=qualityControl.js.map